<template>
  <button
    id="btn-search"
    class="
      btn-innovation btn-innovation-left
      icon-magnifier
      bg-search
      d-lg-inline-block
      tooltipper
    "
    @click.stop="searchModal"
    title="Fikir ve Proje Aramak İçin Tıklayınız."
  >
    FİKİR VE PROJE ARA
    <span class="icon-right"></span>
  </button>
</template>

<script>
export default {
  name: "SearchButton",
  props:["userDetail"],
  methods: {
    searchModal() {
      this.$emit("searchModal", true);
    },
  },
};
</script>

<style>
.icon-magnifier::before {
  padding-top: 11px;
  font-size: 3.9em;
}
</style>